import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSports } from 'features/sport';
import { TMultiSelectList } from 'shared/ui';

export const useSportsOptions = () => {
  const { i18n } = useTranslation();
  const { sportList } = useSports();

  const sportsOptions: TMultiSelectList<number> = useMemo(
    () =>
      sportList.map(el => {
        const locaalizedCaption = el.translations?.find(
          tr => tr.langCode === i18n.language,
        );
        return {
          caption: locaalizedCaption ? locaalizedCaption.value : el.name,
          value: el.id,
        };
      }),
    [i18n.language, sportList],
  );

  return sportsOptions;
};
